// The values are saved configurations' keys and are sent to the backend: do not rename them.
export enum MatchGridColumn {
  AVAILABILITY = 'availability',
  BARRED_LOCATION = 'barredLocation',
  BIO = 'bio',
  COMPENSATION = 'compensation',
  EXPLANATION = 'explanation',
  FEEDBACK_RESPONSES = 'feedbackResponses',
  FEEDBACK_SCORE = 'feedbackScore',
  MIN_WEEKLY_HOURS_PER_POSITION = 'minWeeklyHoursPerPosition',
  OWNER_USER = 'ownerUser',
  PRICING_RANGE = 'pricingRange',
  PROACTIVE = 'proactive',
  PROFILE_STATUS = 'profileStatus',
  RANK = 'rank',
  TALENT_EMAIL = 'talentEmail',
  TALENT_FLAG = 'talentFlag',
  TALENT_LOCATION = 'talentLocation',
  TALENT_NAME = 'talentName',
  TALENT_PHONE_NUMBER = 'talentPhoneNumber',
  YEARS_AT_AXIOM = 'yearsAtAxiom',
  YOE = 'yoe',
}
